import { convertMillimetersToTwip } from "docx";

export const useChecklistCellMargins = () => {
  return {
    top: convertMillimetersToTwip(0.75),
    bottom: convertMillimetersToTwip(0.8),
    right: convertMillimetersToTwip(2),
    left: convertMillimetersToTwip(2),
  };
};
